import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Engagement from './icon-engagement.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Engagement {...validProps} />;
}
SvgComponent.iconName = 'engagement';

export const EngagementIcon = svgIconWrapper(SvgComponent);
